import * as types from "./../mutation-types";
import * as api from "../../modules/api.js";
import router from "../../router";
import { flashControl } from "../../../public/js/flash.js";

export default {
  state: {
    resetToken: null,
    loginHasError: false,
    signupHasError: false,
    signupSuccess: false,
    userInfo: {}
  },
  getters: {
    isAuthenticated(state) {
      return state.userInfo.hasOwnProperty("email");
    }
  },
  mutations: {
    [types.UPDATE_USER_INFO](state, payload) {
      state.userInfo = payload;
    },
    UpdateResetToken(state, payload) {
      state.resetToken = payload;
    },
    UpdateRegisterSuccessState(state, payload) {
      state.signupSuccess = payload;
    },
    UpdateLoginErrorState(state, payload) {
      state.loginHasError = payload;
    },
    UpdateSignupErrorState(state, payload) {
      state.signupHasError = payload;
    }
  },
  actions: {
    notify({ state, commit, dispatch }, m) {
      window.flashMessages = [
        {
          type: m.type,
          icon: 'flash-info',
          message: m.message
        }
      ];
      flashControl.init();
    },
    loadUserByToken({
      state,
      commit,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        api.request(api.info).then(
          function (value) {
            commit(types.UPDATE_USER_INFO, value);
            resolve();
          },
          function (value) {
            resolve();
          }
        );
      });
    },
    login({
      state,
      commit,
      dispatch
    }, payLoad) {
      commit("UpdateLoginErrorState", false);
      api.request(api.login, payLoad).then(
        function (value) {
          commit(types.UPDATE_USER_INFO, value);
          $("#myModal").modal("toggle");
          router.push({
            name: "api-explorer-accounts"
          });
        },
        function (value) {
          var data = value.response.data;
          dispatch('notify', { type: 'warning', message: data.message });
        }
      );
    },
    register({
      state,
      commit,
      dispatch
    }, payLoad) {
      commit("UpdateSignupErrorState", false);
      api.request(api.register, payLoad).then(
        function (value) {
          commit("UpdateRegisterSuccessState", true);
          // $("#myModal").modal("hide");
          dispatch('notify', { type: 'success', message: 'User account is created successfully. You need to confirm your account. Please check your email and continue with registration confirmation email.' });
        },
        function (value) {
          var data = value.response.data;
          dispatch('notify', { type: 'warning', message: data.message });
        }
      );
    },
    forgot({
      state,
      commit,
      dispatch
    }, payLoad) {
      api.request(api.forgot, payLoad).then(
        function (value) {
              dispatch('notify', { type: 'success', message: 'We sent you an email to reset your password. Please check you email and continue with password reset link.' });
        },
        function (value) {
          var data = value.response.data;
            dispatch('notify', { type: 'success', message: data.message });
        }
      );
    },
    newpassword({
      state,
      commit,
      dispatch
    }, payLoad) {
      api.request(api.newPassword, { token: state.resetToken, password: payLoad.password }).then(
        function (value) {
          dispatch('notify', { type: 'success', message: 'Password is changed' });
          $("#myModal").modal("toggle");
        },
        function (value) {
          var data = value.response.data;
          dispatch('notify', { type: 'warning', message: data.message });
        }
      );
    },
    logout({
      state,
      commit,
      dispatch
    }) {
      api.request(api.logout, {}).then(
        function (value) {
          commit(types.UPDATE_USER_INFO, {});
          router.push({
            name: "getting-started"
          });
          dispatch('notify', { type: 'success', message: 'You have been successfully logged out!' });
        },
        function (value) {
          var data = value.response.data;
          dispatch('notify', { type: 'warning', message: data.message });
        }
      );
    },
    loginWindow({
      state,
      commit,
      dispatch
    }) {
      if ($("#first").length !== 0) {
        $("#second").hide();
        $("#third").hide();
        $("#fourth").hide();
        $("#first").fadeIn("fast");
        $("#myModal").modal("show");
      } else {
        router.push({
          name: "getting-started"
        });
      }
    },
    signupWindow({
      state,
      commit,
      dispatch
    }) {
      if ($("#first").length !== 0) {
        $("#third").hide();
        $("#first").hide();
        $("#fourth").hide();
        $("#second").fadeIn("fast");
        $("#myModal").modal("show");
      } else {
        router.push({
          name: "getting-started"
        });
      }
    }
  }
};